import React from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import "./AboutSection.css";
import Register from "./Register";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { FaBook, FaInfinity, FaRegCreditCard, FaUserGraduate } from "react-icons/fa";
import {
    Box,
    Typography,

} from "@mui/material";
import logo1 from "../image/logo11.jpg";
import logo2 from "../image/logo12.jpg";
import logo3 from "../image/logo13.jpg";
import logo4 from "../image/logo14.jpg";
import logo5 from "../image/logo15.jpg";
import logo6 from "../image/logo16.jpg";
import logo7 from "../image/logo17.jpg";
import logo8 from "../image/logo18.jpg";
import image from "../image/Docter_Aboutus.jpeg";


export default function AboutSection() {
    const logos = [logo1, logo2, logo3, logo4, logo5, logo6, logo7, logo8];
    const [isRegisterOpen, setIsRegisterOpen] = useState(false);

    const feature = [
        {
            icon: "🎓",
            title: "Quality Education",
            desc: "We deliver practical, job-oriented courses crafted by industry experts.",
        },
        {
            icon: "👥",
            title: "Community Support",
            desc: "Join a vibrant community of learners and mentors to grow together.",
        },
        {
            icon: "⭐",
            title: "Career Growth",
            desc: "Our courses help you build your confidence and land your dream job.",
        },
        {
            icon: "💬",
            title: "24/7 Mentorship",
            desc: "Get constant mentor guidance whenever you need help with your learning path.",
        },
        {
            icon: "💼",
            title: "Real-World Projects",
            desc: "Gain hands-on experience with projects inspired by real industry challenges.",
        },
        {
            icon: "⏰",
            title: "Learn at Your Pace",
            desc: "Study anytime, anywhere with flexible and accessible learning options.",
        },
    ];


    const features = [
        { icon: <FaBook />, title: "Extensive Resources" },
        { icon: <FaInfinity />, title: "Lifetime Privileges" },
        { icon: <FaRegCreditCard />, title: "Affordable Education" },
        { icon: <FaUserGraduate />, title: "Dedicated Support" },
    ];

    const navigate = useNavigate();

    const goToContact = () => {
        navigate("/contact"); // 👈 navigate to Contact page
    };

    const gotoregister = () => {
        navigate("/register"); // 👈 navigate to Register page

    }


    return (
        <>
            {<Navbar />}


            <section className="top-section">
                <Box
                    sx={{
                        background: '#8a88bc',
                        color: "white",
                        textAlign: "center",
                        py: { xs: 6, md: 10 },
                    }}
                >

                    <Typography variant="h3" fontWeight="bold" gutterBottom>
                        About Medby Academy
                    </Typography>

                    <Typography variant="h6" maxWidth="700px" mx="auto">
                        Empowering students with skills and knowledge for a brighter future.
                    </Typography>
                </Box>
            </section>

            <section className="about-section">
                <div className="container about-container">
                    {/* Left Content */}
                    <div className="about-text">
                        <h6 className="subtitle">ABOUT US</h6>
                        <h2 className="title">
                            Empowering Healthcare Professionals with
                            <span> World-Class Online Education</span>
                        </h2>
                        <p>
                            Best Academy of Medical Science In Noida – Medby Academy provides
                            online educational opportunities tailored for healthcare
                            professionals seeking to pursue Continuing Professional
                            Development (CPD), Certificates, Postgraduate Diplomas,
                            Fellowships, and Diploma courses without interrupting their
                            demanding work commitments.
                        </p>
                        <p>
                            Our adaptable online programs are fully accredited by both Indian
                            and international universities and are designed by medical
                            specialists from across the globe, ensuring a high standard of
                            education that fits seamlessly into the busy lives of healthcare
                            practitioners.
                        </p>

                        {/* Bullet Point */}
                        <div className="about-bullet">
                            <span className="check-icon">✔</span>
                            <p>Your Gateway to World-Class Medical Learning</p>
                        </div>

                        {/* Buttons */}
                        <div className="about-buttons">
                            <button
                                className="modern-btn"
                                onClick={() => setIsRegisterOpen(true)}
                            >
                                Register
                            </button>

                            <Register
                                isOpen={isRegisterOpen}
                                onClose={() => setIsRegisterOpen(false)}
                            />
                            <button className="modern-btn" onClick={goToContact}>CONTACT US</button>
                        </div>
                    </div>

                    {/* Right Image */}
                    <div className="about-image">
                        <img
                            src={image}
                            alt="About Us"
                        />
                    </div>
                </div>
            </section>

            <section className="mission-section">
                <h2 className="mission-title">Our Mission</h2>
                <div className="mission-grid">
                    {feature.map((item, index) => (
                        <div className="mission-card" key={index}>
                            <div className="mission-icon">{item.icon}</div>
                            <h3>{item.title}</h3>
                            <p>{item.desc}</p>
                        </div>
                    ))}
                </div>
            </section>



            <section className="partners-section">
                <div className="partners-container">
                    {/* Left Side Text */}
                    <div className="partners-text">
                        <h6 className="subtitle">OUR TRUSTED PARTNERS</h6>
                        <h2>
                            We are proud to have <br />
                            over <span>20+ global partners</span> <br />
                            supporting Medby Academy.
                        </h2>
                    </div>

                    {/* Right Side Logos */}
                    <div className="partners-logos">
                        {logos.map((logo, index) => (
                            <div key={index} className="logo-card">
                                <img src={logo} alt={`Partner ${index + 1}`} />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {<Footer />}
        </>

    );
}
